import { GroupResource } from '@libs/sports-api-resources';

export const enum StandingItemStatus {
    Active = 'active',
    Deleted = 'deleted'
}

export const enum StandingStage {
    RegularSeason = 1,
    FinalRound = 126
}

export const enum Subtype {
    Standings = 'standings',
    StandingsLive = 'standings_live',
    UnderOver = 'under_over',
    Form = 'form',
    OverallStats = 'overall_stats'
}

export enum ObjectType {
    Sport = 'sport',
    Season = 'season',
    Competition = 'competition',
    Stage = 'stage',
    Event = 'event'
}

export interface Standing {
    id: number
    name: string
    sport_id: number
    type_id: number
    type_name: string
    subtype: Subtype
    object_id: number
    object_type: ObjectType
    object_name: string
    competition_id: number
    season_id: number
    stage_id: number
    stage_name_id: number
    ut: number
    groups: GroupResource[]
}

export interface StandingIndex {
    id: number
    name: string
    type_id: number
    type_name: string
    object_id: number
    object_name: string
    object_type: ObjectType
}
